import React from 'react';

/**
 * Mobile-first Bottom Navigation Bar
 * Optimized for thumb zone ergonomics (bottom 1/3 of screen)
 * Hidden on desktop (md breakpoint and above)
 */
function BottomNavigation({ onSearchClick, onIndexClick, onSettingsClick, hasBookmarks, onBookmarksClick }) {
  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden backdrop-blur-md"
      style={{
        background: 'var(--bg-overlay)',
        borderTop: '1px solid var(--border-subtle)',
        paddingBottom: 'calc(var(--safe-area-bottom) + 0.5rem)',
        paddingLeft: 'var(--safe-area-left)',
        paddingRight: 'var(--safe-area-right)',
      }}
    >
      <div className="flex items-center justify-around px-2 pt-3">
        {/* Search Button */}
        <button
          onClick={onSearchClick}
          className="flex flex-col items-center gap-1 px-4 py-2 rounded-lg transition-all active:scale-95 active:opacity-70"
          style={{
            color: 'var(--text-secondary)',
            minHeight: '48px', // WCAG touch target
            minWidth: '48px',
          }}
          aria-label="Search Surahs"
        >
          <span className="text-2xl">🔍</span>
          <span className="text-xs font-medium">Search</span>
        </button>

        {/* Index Button */}
        <button
          onClick={onIndexClick}
          className="flex flex-col items-center gap-1 px-4 py-2 rounded-lg transition-all active:scale-95 active:opacity-70"
          style={{
            color: 'var(--text-secondary)',
            minHeight: '48px',
            minWidth: '48px',
          }}
          aria-label="Browse All Surahs"
        >
          <span className="text-2xl">📖</span>
          <span className="text-xs font-medium">Index</span>
        </button>

        {/* Bookmarks Button (conditional) */}
        {hasBookmarks && (
          <button
            onClick={onBookmarksClick}
            className="flex flex-col items-center gap-1 px-4 py-2 rounded-lg transition-all active:scale-95 active:opacity-70"
            style={{
              color: 'var(--text-secondary)',
              minHeight: '48px',
              minWidth: '48px',
            }}
            aria-label="Bookmarks & Notes"
          >
            <span className="text-2xl">📚</span>
            <span className="text-xs font-medium">Saved</span>
          </button>
        )}

        {/* Settings Button (only in surah detail view) */}
        {onSettingsClick && (
          <button
            onClick={onSettingsClick}
            className="flex flex-col items-center gap-1 px-4 py-2 rounded-lg transition-all active:scale-95 active:opacity-70"
            style={{
              color: 'var(--text-secondary)',
              minHeight: '48px',
              minWidth: '48px',
            }}
            aria-label="Reading Settings"
          >
            <span className="text-2xl">⚙️</span>
            <span className="text-xs font-medium">Settings</span>
          </button>
        )}
      </div>
    </nav>
  );
}

export default BottomNavigation;

